import { Component, ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { hasError: boolean; error?: Error }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', background: '#080C18',
          color: '#E8EFF8', fontFamily: "'DM Sans', sans-serif", gap: '1rem',
          padding: '2rem', textAlign: 'center',
        }}>
          <div style={{ fontSize: '2rem', color: '#00D4FF' }}>!</div>
          <h2 style={{ margin: 0 }}>Something went wrong</h2>
          <p style={{ color: '#8A9BB5', maxWidth: '400px' }}>
            An unexpected error occurred. Please refresh the page or contact support if the problem persists.
          </p>
          <button
            onClick={() => { window.location.href = '/'; }}
            style={{
              background: 'rgba(0,212,255,0.08)', color: '#00D4FF',
              border: '1px solid #00D4FF', borderRadius: 8,
              padding: '0.75rem 1.5rem', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif", fontSize: '0.9rem',
            }}
          >
            Return to Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
